<template>
  <div> <!-- div to add classes eg: mr-4 (not supported by AppTooltip) -->
    <AppTooltip max-width="300"
                :location="location"
                :disabled="!tooltipText"
    >
      <template #activator="{ props }">
        <div v-bind="{ ...props, ...$attrs }">
          <AppTextField
            v-model="searchQuery"
            :class="{'SearchInput--fluid': fluid, 'SearchInput': !fluid}"
            data-locator="search-input"
            :placeholder="placeholder"
            :hint="hint"
            class="bg-white"
            clearable
            :disabled="disabled"
            hide-details
            prepend-inner-icon="search"
            :icon-color="disabled ? 'icon-disabled' : 'icon-primary'"
            @clear="onClear"
            @blur="$emit('blur')"
          />
        </div>
      </template>
      <span>{{ tooltipText }}</span>
    </AppTooltip>
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'

import AppTextField from './AppTextField.vue'
import AppTooltip from './AppTooltip.vue'
/**
 * @displayName SearchTextField
*/
/**
 * A v-text-field with custom behavior for search use-cases.
 * @see  v-text-field from Vuetify (https://vuetifyjs.com/en/api/v-text-field/)
 * */
export default {
  name: 'SearchTextField',
  components: {
    AppTooltip,
    AppTextField,
  },
  inheritAttrs: false,
  emits: [
    'clear',
    'blur',
    'update:modelValue',
  ],
  /**
   * props from v-text-field from Vuetify (https://vuetifyjs.com/en/api/v-text-field/) are also available
   */
  props: {
    /**
     * @model
     * Value passed from parent
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
    fluid: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: function () {
        return i18n.global.t('common.SearchTextField.search')
      },
    },
    hint: {
      type: String,
      default: '',
    },
    tooltipText: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: 'bottom',
    },
  },
  computed: {
    searchQuery: {
      get () { return this.modelValue },
      set (val) {
        if (val === null) {
          this.$emit('update:modelValue', '')
        } else {
          this.$emit('update:modelValue', val)
        }
      },
    },
  },
  methods: {
    onClear () {
      this.$emit('clear')
    },
  },
}
</script>

<style scoped lang="scss">
.SearchInput {
  width: 200px;
  max-width: 200px;
  transition: max-width .25s ease-in-out;
  &--fluid {
    max-width: 100%;
  }
}

:deep(.theme--light.SearchInput.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset) {
  color: #bdbdbd;
}

.SearchInput :deep(.v-icon) {
  font-size: 16px;
}

.v-application--is-ltr .SearchInput :deep(.v-input__prepend-inner) {
  padding-right: 12px;
}

.SearchInput :deep(.v-input__prepend-inner.v-icon) {
  color: #333;
}
</style>
